import React, { Component } from 'react';

import { Row, Col} from 'antd';
import { Margin } from 'styled-components-spacing';
import Center from 'react-center';
import { Player } from 'video-react';
import videoPoster from "../../../Imgs/AboutUs/ManagerMessage/managerPosterVideo.PNG";
import LazyLoad from 'react-lazyload';

// CSS Files
import "../../../Fonts/Fonts.css";
import "../../../Statics/Common/FontStyle.css";
import "../../../Statics/AboutUs/ManagerMessage/ManagerMessage.css";

const managerMessageCard ={
    borderRadius:"20px",
    boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
}

const MessageCard = props => {
    
     return props.size === "laptopdesktop" ? (
        <div className="managerMessageBackground">
            <div style={{paddingTop:"100px"}}>
                <Center>
                        <p className="mainTitle mainTitleBorderRight mainTitleBorderLeft"><strong>سخن مدیرعامل</strong></p>
                </Center>
                <Center>
                    <Margin top={2}>
                        <p className="mainTitleDescription">ایرانیان پوشش از زبان مدیرعامل</p>
                    </Margin>
                </Center>
            </div>
            <Row style={{marginTop:"75px"}}>
                <Col span={4}></Col>
                <Col span={16}>
                    <div style={managerMessageCard}>
                           <Row>
                                <Col span={8}>
                                   <div style={{backgroundColor:"#f5f5f5" ,borderRadius:"20px 0 0 0" , padding:"20px" , height:"100%"}}>
                                     <LazyLoad>
                                        <Center>
                                            <img
                                                style={{ width:"95%"}}
                                                src={require("../../../Imgs/AboutUs/ManagerMessage/managerMess.jpg")}
                                            />
                                        </Center>
                                        </LazyLoad>
                                        <Margin top={3}></Margin>
                                        <Row style={{direction:"rtl" , textAlign:"right"}}>
                                            <div className="personRightBorder" style={{direction:"rtl", textAlign:"right" , marginRight:"6.5px"}}></div>
                                            <div style={{marginTop:"-2.5px"}}>
                                                <strong style={{fontFamily:"IranSans" , fontSize:".95em" , color:"#174561" , paddingRight:"5px"}}>مهندس ابراهیم ایران نژاد</strong>
                                                <p style={{fontFamily:"IranSans" , fontSize:".85em", color: "#8d8d8d", paddingRight:"5px"}}>مدیرعامل ایرانیان پوشش</p>
                                            </div>
                                        </Row>
                                        <p className="textParagraph" style={{marginRight:"6.5px" , marginLeft:"6.5px"}}>
                                        امیدوارم، مجموعه شرکت های ایرانیان پوشش به پشتوانه ذخیره مناسب سرمایه های اجتماعی و انسانی ارزشمندش بتواند، به مثابه نهادی حرفه ای برای بیمه گران،   بیمه گذاران و همچنین نهادهای سیاستگذار بیمه ای کشور اعتمادآور و اطمینان بخش باشد و در پرتو مسئولیت اجتماعی اش با عرضه خدمات پر کیفیت و رضایت بخش در زمینه ارزیابی خسارت و ریسک بیمه ای اعتماد آن ها را بیش از پیش به توانمندی ها و قابلیت هایش جلب کند.
                                        </p>
                                   </div>
                               </Col>
                               <Col span={16} style={{direction:"rtl" , textAlign:"right",backgroundColor:"#fff",borderRadius:"0 20px 20px 0"}}>
                                    <Margin top={3}></Margin>
                                    <div style={{paddingRight:"30px" , paddingLeft:'30px'}}>
                                        <p className="textParagraph">
                                        به نام خالق زیبایی، دانایی و نیکویی
                                        </p>
                                        <p className="textBoldParagraph">
                                             <strong>
                                             دانه ایرانیان پوشش در ۱۳ آذر سال ۱۳۹۱ کاشت شد و
سیزدهم آذر امسال آغاز دوازدهمین سالگرد فعالیت این مجموعه است.

                                             </strong>
                                        </p>
                                        <p className="textParagraph">
                                        آنان که دستی بر آتش دارند، نیک می‌دانند که در حضور تهدیدها و مخاطراتی چون فضای نامناسب کسب‌وکارها، تحریم‌های اقتصادی، نرخ‌های بالای تورم، محدودیت نقدینگی، نوسانات شدید نرخ ارز، بی‌ثباتی در سیاست‌گذاری‌ها و مداخله‌های غیرهوشمندانه دولت در بازارهای اقتصادی، این شروع و تداوم فعالیت تا چه اندازه کاری شاق و پرهزینه بوده است، بااین‌وجود، سختی راه و سنگلاخی بودن، ناهمواری‌ها و فرازوفرودهای مسیر را با خلق دستاوردهایی در حوزه ارزیابی خسارت و ارزیابی ریسک در همه رشته‌های بیمه‌ای معنادار کردیم.
                                        <br/>
                                        در این ۱۲ سال ۱۲ شرکت راه‌اندازی کردیم و با شعاره ایستگاه نوآوری صنعت بیمه - منهای فروش هرسال یک شرکت جدید را وارد صنعت بیمه نمودیم و هم‌اکنون با خلق نوآوری‌ها با شرکت‌ها و مؤسسات شناخته‌شده‌ای ازجمله اندیشکده بیمه، دادگر بیمه، دادرس بیمه، همیار بیمه، سناپ، سپر، کنکاش بیمه، رفاپ، امداد و نجات، آژانس بیمه، رسانه بیمه از صنعت بیمه کشور مراقبت کردیم، در دل بیمه‌گزاران اعتماد کاشتیم و امیدشان را به این نهاد اطمینان‌بخش افزایش دادیم، یار شرکت‌های بیمه‌گر بودیم و از بار آن‌ها کم کردیم و باعرضه خدمات پر کیفیت ارزیابی خسارت به بیمه‌گزارانشان اهمیت و ارزشمندی خدمات شرکت‌های بیمه‌ای را برجسته ساختیم.
                                        <br/>
                                        در بیش از یک دهه مجال حضور، مهربانانه دست آسیب دیدگان و در راه ماندگان بیمه‌ای را گرفتیم و در دلشان شادی آفریدیم.
                                        <br/>
                                        از همان آغاز کار رویکردمان این بود که در مسیر توسعه صنعت بیمه و افزایش ضریب نفوذ بیمه در کشور، یاریگر نهادهای سیاست‌گذار و هردوی بیمه گران و بیمه‌گزاران باشیم. اکنون، پس از گذشت این‌همه سال که کارنامه خانواده ایرانیان پوشش را مرور می‌کنیم و بازخوردهای مثبت نهادهای ناظر، سیاست‌گذار، شرکت‌های بیمه و بیمه‌گزاران حقیقی و حقوقی را می‌بینیم، خدای مهربان را برای این توفیقات شکر می‌گوییم. این عملکرد در حالی حاصل‌شده که شرکت جدا از فعالیت حرفه‌ای و خدماتی خود، همواره مسئولیت اجتماعی خود را در قبال جامعه ادا کرده و در این زمینه نیز سرآمد بوده است.
                                        <br/>
                                        سالروز تولد ایرانیان پوشش و نام نیکی را که در صنعت بیمه کشور کسب کرده است را به همه مدیران، کارکنان و خانواده ایرانیان پوشش تبریک عرض می‌کنم. به همه این عزیزان دست‌مریزاد و خداقوت می‌گویم و از خدای متعال سلامتی، شادی و آرامش را برایشان خواستارم.
                                        <br/>
                                        <br/>
                                        ابراهیم ایران‌نژاد
                                        <br/>
                                        مدیرعامل گروه شرکت‌های ایرانیان پوشش  
                                        </p>
                                   </div>
                               </Col>
                           </Row>
                           <Row>
                               <hr style={{border: "0.01em dashed #4983C4" , width:"100%" , marginTop:"0px" , opacity:"60%"}}/>
                           </Row>
                           <Row>
                               <Col span={5}></Col>
                               <Col span={14}>
                                    <Margin top={3}></Margin>
                                    <Player
                                    
                                        playsInline
                                        poster={videoPoster}
                                        src="https://ipinsur.ir/wp-content/uploads/2018/07/2000Shoghl.mp4?_=1"
                                    />
                                    <Margin top={4}></Margin>
                               </Col>
                               <Col span={5}></Col>
                           </Row>
                       </div>
                </Col>
                <Col span={4}></Col>
            </Row>
        </div>
     ) : props.size === "tablet" ? (
        <div className="managerMessageBackground">
        <div style={{paddingTop:"75px"}}>
            <Center>
                    <p className="mainTitleTablet mainTitleBorderRight mainTitleBorderLeft"><strong>سخن مدیرعامل</strong></p>
            </Center>
            <Center>
                <Margin top={2}>
                    <p className="mainTitleDescriptionTablet">ایرانیان پوشش از زبان مدیرعامل</p>
                </Margin>
            </Center>
        </div>
        <Row style={{marginTop:"25px"}}>
            <Col span={1}></Col>
            <Col span={22}>
                <div style={managerMessageCard}>
                       <Row>
                            <Col span={9}>
                               <div style={{backgroundColor:"#f5f5f5" ,borderRadius:"20px 0 0 0" , padding:"20px" , height:"100%"}}>
                                         <LazyLoad>
                                    <Center>
                                        <img
                                            style={{ width:"85%"}}
                                            src={require("../../../Imgs/AboutUs/ManagerMessage/managerMess.jpg")}
                                        />
                                    </Center>
                                             </LazyLoad>
                                    <Margin top={3}></Margin>
                                    <Row style={{direction:"rtl" , textAlign:"right"}}>
                                        <div className="personRightBorder" style={{direction:"rtl", textAlign:"right" , marginRight:"13px"}}></div>
                                        <div style={{marginTop:"-2.5px"}}>
                                            <strong style={{fontFamily:"IranSans" , fontSize:".85em" , color:"#174561" , paddingRight:"5px"}}>مهندس ابراهیم ایران نژاد</strong>
                                            <p style={{fontFamily:"IranSans" , fontSize:".75em", color: "#8d8d8d", paddingRight:"5px"}}>مدیرعامل ایرانیان پوشش</p>
                                        </div>
                                    </Row>
                                    <p className="textParagraphTablet" style={{marginRight:"6.5px" , marginLeft:"6.5px"}}>
                                    امیدوارم، مجموعه شرکت های ایرانیان پوشش به پشتوانه ذخیره مناسب سرمایه های اجتماعی و انسانی ارزشمندش بتواند، به مثابه نهادی حرفه ای برای بیمه گران،   بیمه گذاران و همچنین نهادهای سیاستگذار بیمه ای کشور اعتمادآور و اطمینان بخش باشد و در پرتو مسئولیت اجتماعی اش با عرضه خدمات پر کیفیت و رضایت بخش در زمینه ارزیابی خسارت و ریسک بیمه ای اعتماد آن ها را بیش از پیش به توانمندی ها و قابلیت هایش جلب کند.
                                    </p>
                               </div>
                           </Col>
                           <Col span={15} style={{direction:"rtl" , textAlign:"right",backgroundColor:"#fff",borderRadius:"0 20px 20px 0"}}>
                                <Margin top={3}></Margin>
                                <div style={{paddingRight:"30px" , paddingLeft:'30px'}}>
                                    <p className="textParagraphTablet">
                                    در سال ۱۳۹۱ مصادف با سال تولید ملی، حمایت از کار و سرمایه ایرانی و در لبیک به فرمایش مقام معظم رهبری ایده فعالیت شرکت ایرانیان پوشش مطرح و در ١٣ آذر ، یعنی روز بیمه، همان سال ثبت شد. اما به دلیل فراهم نبودن بسترهای نهادی و قانونی و تغییر آیین نامه شورایعالی بیمه عملا در نیمه دوم سال ۱۳۹۴ با اخذ مجوز رسمی از بیمه مرکزی با شعار پر صلابت مراقب بیمه (حافظ رابطه بیمه گر و   بیمه گذار) به عنوان نخستین شرکت ارزیابی خسارت بیمه ای رسما آغاز به کار کردیم. از همان ابتدا، برای تضمین حقوق بیمه گر و بیمه گذار، چهار اصل حیاتی
<br/>
۱) استقلال و بی طرفی
<br/>
۲) دقت توام با سرعت عمل
<br/>
۳) امانت و رازداری 
<br/>
۴) رعایت اخلاق حرفه ای
<br/>
را سرلوحه خدمات خود قرار دادیم. در این مدت کوتاه با استعانت از خدای متعال و با پشتوانه سرمایه اجتماعی موجود در شرکت، این نهاد نوپا را پرورش دادیم و حقیقتا امروز همچون درخت تنومندی شاخ و برگ زیادی به خود گرفته ایم. به مثابه یک شرکت جنرال در تمامی حوزه های بیمه ای از بیمه مرکزی مجوز رسمی گرفته و فعالیت خود را توسعه داده ایم.                                             

                                    </p>
                                    <p className="textBoldParagraphTablet">
                                         <strong>
                                         ایرانیان پوشش با شعار پر صلابت مراقب بیمه (حافظ رابطه بیمه گر و   بیمه گذار) رسما آغاز به کار کرد و از همان ابتدا،تضمین حقوق بیمه گر و   بیمه گذار، را سرلوحه خدمات خود قرار دادیم

                                         </strong>
                                    </p>
                                    <p className="textParagraphTablet">
                                        به علاوه، مجوزهای رسمی  چند شرکت وموسسه دیگر مرتبط بیمه ای از جمله خبرگزاری مراقب بیمه و رادیو بیمه، آموزشگاه فنی وحرفه ای آزاد ایرانیان پوشش، موسسه وکالت وریکاوری  بیمه گری بنام دادگر بیمه ، همیار بیمه  (پلیس خصوصی بیمه ) شرکت نرم افزاری سناپ ، موسسه کنکاش ، موسسه پژوهشی وعلمی اندیشکده بیمه ،دادرس بیمه ، شرکت ایمن دیار تاسیس نموده ایم و با تاسیس اثربخش این هلدینگ توانسته ایم بر توانمندی های شرکت بیفزاییم و خدمات ارزنده ای به جامعه بیمه ای کشور ارائه دهیم. از جمله اقدامات دیگر سیاستی شرکت برای توسعه فعالیت، ایجاد بیش از۴٠ شعبه در ۳۱ استان کشور است. توسعه فعالیت شرکت در اقصی نقاط کشور به ما امکان خدمتگذاری بهتر و بیش تر و عرضه خدمات ارزیابی با سه ویژگی کیفیت بهتر، سرعت بیش تر، و قیمت پایین تر داده است.  از تاسیس شرکت ایرانیان پوشش تا به امروز، مسیر زیادی را در زمان کوتاهی به لطف حضرت حق و تلاش های خستگی ناپذیر و مسئولانه نیروی انسانی شرکت طی کرده ایم. سیاست ما حفظ سرمایه انسانی تربیت شده در شرکت و ارتقای توانمندی های آن ها بوده است. در این راستا، با افتخار اعلام می داریم که در این زمینه موفق عمل کرده ایم و ضمن حفظ تمامی نیروهای انسانی که از ابتدای راه با ما بوده اند، نیروهای انسانی زیادی را نیز جذب کرده و فرصت های شغلی مولدی را برای اقتصاد کشور ایجاد کرده ایم. جذب و تربیت بیش از ۲۰۰۰ نیروی انسانی در حوزه بیمه ای، و همچنین رضایت بیمه گران و   بیمه گذاران از خدمات ارزیابی شرکت ایرانیان پوشش و مطرح نشدن حتی یک مورد شکایت از خدمات ارائه شده به مشتریان، گواهی آشکار بر موفقیت عملکرد و از افتخارات ایرانیان پوشش است. شرکت سهامی ارزیابی خسارت و ریسک ایرانیان پوشش، نخستین و تنها شرکت جامع ارزیابی خسارت در کلیه رشته ها از بیمه مرکزی مجوز اخذ نموده است که با گسترده ترین شبکه خدمات ارزیابی خسارت بیمه ای در اقصی نقاط ایران عزیز، هر جا و هر زمان که مورد نیاز باشد، به راحتی با یک تماس تلفنی چهار رقمی و بدون کد  بشماره  ۱۴۰۱ (یک چهل یک)  ، یا از راه اپلیکیشن  وب اپلیکیشن Arzyab24.com می تواند به یاری خسارت دیدگان و شرکت های بیمه گر بشتابد. این شرکت اخیراً شعبه الکترونیکی پرداخت خسارت سیار شبانه روزی راه انداری نموده است که با اعزام ارزیاب سیار زیان دیده بدون مراجعه حضوری خسارت را دریافت می نمایند.
                                    <br/>
                                    امیدوارم، مجموعه شرکت های ایرانیان پوشش به پشتوانه ذخیره مناسب سرمایه های اجتماعی و انسانی ارزشمندش بتواند، به مثابه نهادی حرفه ای برای بیمه گران،   بیمه گذاران و همچنین نهادهای سیاستگذار بیمه ای کشور اعتمادآور و اطمینان بخش باشد و در پرتو مسئولیت اجتماعی اش با عرضه خدمات پر کیفیت و رضایت بخش در زمینه ارزیابی خسارت و ریسک بیمه ای اعتماد آن ها را بیش از پیش به توانمندی ها و قابلیت هایش جلب کند.
                                    </p>
                               </div>
                           </Col>
                       </Row>
                       <Row>
                           <hr style={{border: "0.01em dashed #4983C4" , width:"100%" , marginTop:"0px" , opacity:"60%"}}/>
                       </Row>
                       <Row>
                           <Col span={5}></Col>
                           <Col span={14}>
                                <Margin top={3}></Margin>
                                <Player
                                
                                    playsInline
                                    poster={videoPoster}
                                    src="https://ipinsur.ir/wp-content/uploads/2018/07/2000Shoghl.mp4?_=1"
                                />
                                <Margin top={4}></Margin>
                           </Col>
                           <Col span={5}></Col>
                       </Row>
                   </div>
            </Col>
            <Col span={1}></Col>
        </Row>
    </div>
     ) : (
        <div className="managerMessageBackground">
            <div style={{ paddingTop: "75px" }}>
                <Center>
                    <p className="mainTitleMobile mainTitleBorderRightMobile mainTitleBorderLeftMobile"><strong >سخن مدیرعامل</strong></p>
                </Center>
                <Center>
                    <Margin top={2}>
                        <p className="mainTitleDescriptionMobile">ایرانیان پوشش از زبان مدیرعامل</p>
                    </Margin>
                </Center>
            </div>
            <div>
                <Row style={{marginTop:"25px"}}>
                    <Col span={1}></Col>
                    <Col span={22}>
                        <div style={{ boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)", backgroundColor: "#fff", height: "100%", borderRadius: "20px" }}>
                            <div style={{ backgroundColor: "#f6f6f6", borderRadius: "20px" }}>
                                         <Center>
                                             <LazyLoad>
                                                 
                                                    <Margin top={2}>
                                                     <Center>
                                                         <img
                                                             style={{ width: "50%", borderRadius: "50%" }}
                                                             src={require("../../../Imgs/AboutUs/ManagerMessage/managerMess.jpg")}
                                                         />
                                                     </Center>
                                                    </Margin>
                                                
                                             </LazyLoad>
                                         </Center>
                                <Center>
                                    <Margin top={2}>
                                        <Center>
                                                <strong style={{ fontFamily: "IranSans", fontSize: ".8em", color: "#174561", paddingRight: "10px" }}>
                                                    دکتر ابراهیم ایران نژاد
                                                </strong>
                                        </Center>
                                        <Center>
                                                <p style={{ fontFamily: "IranSans", fontSize: ".75em", color: "#8d8d8d", paddingRight: "10px", marginTop: "5px", textAlign: "center" }}>
                                                    مدیرعامل ایرانیان پوشش
                                                </p>
                                        </Center>
                                    </Margin>
                                </Center>
                                
                                <Center>
                                    <div className="cardTitleHR"></div>
                                </Center>
                                <Margin top={2}></Margin>
                                <div style={{ padding:"15px", backgroundColor: "#fff" , borderRadius:"0 0 20px 20px" }}>
                                <p className="textParagraph">
                                        به نام خالق زیبایی، دانایی و نیکویی
                                        </p>
                                        <p className="textBoldParagraph">
                                             <strong>
                                             دانه ایرانیان پوشش در ۱۳ آذر سال ۱۳۹۱ کاشت شد و
سیزدهم آذر امسال آغاز دوازدهمین سالگرد فعالیت این مجموعه است.

                                             </strong>
                                        </p>
                                        <p className="textParagraph">
                                        آنان که دستی بر آتش دارند، نیک می‌دانند که در حضور تهدیدها و مخاطراتی چون فضای نامناسب کسب‌وکارها، تحریم‌های اقتصادی، نرخ‌های بالای تورم، محدودیت نقدینگی، نوسانات شدید نرخ ارز، بی‌ثباتی در سیاست‌گذاری‌ها و مداخله‌های غیرهوشمندانه دولت در بازارهای اقتصادی، این شروع و تداوم فعالیت تا چه اندازه کاری شاق و پرهزینه بوده است، بااین‌وجود، سختی راه و سنگلاخی بودن، ناهمواری‌ها و فرازوفرودهای مسیر را با خلق دستاوردهایی در حوزه ارزیابی خسارت و ارزیابی ریسک در همه رشته‌های بیمه‌ای معنادار کردیم.
                                        <br/>
                                        در این ۱۲ سال ۱۲ شرکت راه‌اندازی کردیم و با شعاره ایستگاه نوآوری صنعت بیمه - منهای فروش هرسال یک شرکت جدید را وارد صنعت بیمه نمودیم و هم‌اکنون با خلق نوآوری‌ها با شرکت‌ها و مؤسسات شناخته‌شده‌ای ازجمله اندیشکده بیمه، دادگر بیمه، دادرس بیمه، همیار بیمه، سناپ، سپر، کنکاش بیمه، رفاپ، امداد و نجات، آژانس بیمه، رسانه بیمه از صنعت بیمه کشور مراقبت کردیم، در دل بیمه‌گزاران اعتماد کاشتیم و امیدشان را به این نهاد اطمینان‌بخش افزایش دادیم، یار شرکت‌های بیمه‌گر بودیم و از بار آن‌ها کم کردیم و باعرضه خدمات پر کیفیت ارزیابی خسارت به بیمه‌گزارانشان اهمیت و ارزشمندی خدمات شرکت‌های بیمه‌ای را برجسته ساختیم.
                                        <br/>
                                        در بیش از یک دهه مجال حضور، مهربانانه دست آسیب دیدگان و در راه ماندگان بیمه‌ای را گرفتیم و در دلشان شادی آفریدیم.
                                        <br/>
                                        از همان آغاز کار رویکردمان این بود که در مسیر توسعه صنعت بیمه و افزایش ضریب نفوذ بیمه در کشور، یاریگر نهادهای سیاست‌گذار و هردوی بیمه گران و بیمه‌گزاران باشیم. اکنون، پس از گذشت این‌همه سال که کارنامه خانواده ایرانیان پوشش را مرور می‌کنیم و بازخوردهای مثبت نهادهای ناظر، سیاست‌گذار، شرکت‌های بیمه و بیمه‌گزاران حقیقی و حقوقی را می‌بینیم، خدای مهربان را برای این توفیقات شکر می‌گوییم. این عملکرد در حالی حاصل‌شده که شرکت جدا از فعالیت حرفه‌ای و خدماتی خود، همواره مسئولیت اجتماعی خود را در قبال جامعه ادا کرده و در این زمینه نیز سرآمد بوده است.
                                        <br/>
                                        سالروز تولد ایرانیان پوشش و نام نیکی را که در صنعت بیمه کشور کسب کرده است را به همه مدیران، کارکنان و خانواده ایرانیان پوشش تبریک عرض می‌کنم. به همه این عزیزان دست‌مریزاد و خداقوت می‌گویم و از خدای متعال سلامتی، شادی و آرامش را برایشان خواستارم.
                                        <br/>
                                        <br/>
                                        ابراهیم ایران‌نژاد
                                        <br/>
                                        مدیرعامل گروه شرکت‌های ایرانیان پوشش  
                                        </p>
                                </div>
                            </div>
                            <hr style={{border: "0.01em dashed #4983C4" , width:"90%" , marginTop:"-15px" , opacity:"60%"}}/>
                            <Row>
                                <Col span={2}></Col>
                                <Col span={20}>
                                    <Player
                                        
                                        playsInline
                                        poster={videoPoster}
                                        src="https://ipinsur.ir/wp-content/uploads/2018/07/2000Shoghl.mp4?_=1"
                                    />
                                    <Margin bottom={3}></Margin>
                                </Col>
                                <Col span={2}></Col>
                            </Row>
                        </div>
                    </Col>
                    <Col span={1}></Col>
                </Row>
            </div>
        </div>
          );
};

export default MessageCard;
